// extracted by mini-css-extract-plugin
export var sbShowMain = "socialMedia-module--sb-show-main--Uzmqm";
export var socialList = "socialMedia-module--socialList--4G8SW";